/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type FileKind = 'matter' | 'message' | 'report_doc' | 'receipt' | 'invoice' | 'salary' | 'tmp' | 'notice' | 'acceptance_report';

export const FileKind = {
    Matter: 'matter' as FileKind,
    Message: 'message' as FileKind,
    ReportDoc: 'report_doc' as FileKind,
    Receipt: 'receipt' as FileKind,
    Invoice: 'invoice' as FileKind,
    Salary: 'salary' as FileKind,
    Tmp: 'tmp' as FileKind,
    Notice: 'notice' as FileKind,
    AcceptanceReport: 'acceptance_report' as FileKind
};

